// src/config/api.js
const RAW_INPUT = import.meta.env.VITE_API_BASE_URL || "http://localhost:5300";
/** Strip trailing slashes and duplicate /api suffix (e.g. https://showtimebro.com/api → origin only) */
function normalizeApiOrigin(raw) {
  let base = String(raw || "").trim().replace(/\/+$/, "");
  if (base.endsWith("/api")) base = base.slice(0, -4);
  return base;
}
const ORIGIN = normalizeApiOrigin(RAW_INPUT);
export const BASE_URL = `${ORIGIN}/`;
export const API_BASE_ORIGIN = ORIGIN;

export const API = {
  base: ORIGIN, // API origin without trailing slash
  auth: {
    sendOtp: "api/user/sendOtp",
    verifyMobileOtp: "api/user/verifyMobileOTP",
    registerUserOtp: "api/user/registerUserOTP",
    getProfile: "api/user/getUserById",
    updateProfile: "api/user/updateUserProfile",
  },
  events: {
    createEvent: "/api/event/createEvent",
    fileUploader: "/api/fileUploader",
    getEvent: "/api/event/getAllEvents",
    getSinglEvent: `/api/event/getEventById`,
    editEvent: "/api/event/updateEvent",
    deleteEvent: "/api/event/deleteEvent",
    featured: "events/featured",
    trending: "events/trending",
    weekend: "events/weekend",
    detail: (id) => `events/${id}`,
    eventStats: (eventId) => `api/event/getEventStats/${eventId}`,
  },
  admin: {
    stats: "admin/stats", // <-- ensure these keys exist and match backend
    events: "admin/events",
    eventById: (id) => `admin/events/${id}`,
    orders: "admin/orders",
    orderById: (id) => `admin/orders/${id}`,
  },
  banner: {
    create: "/api/banner/createBanner",
    list: "/api/banner/getAllBanners",
    update: "/api/banner/updateBanner",
    delete: "/api/banner/deleteBanner",
    getOne: "/api/banner/getBannerById",
  },
  category: {
    category: "/api/event/categoryList",
    Cities: "/api/event/getAllCities",
    ticket: "api/ticket/getAllTickets",
    download: "api/ticket/downloadTicketsAsPDF",
  },
  payout: {
    payout: "/api/payment/create-payment",
    PaymentSuccessful: "/api/payment/verify-payment",
  },
  coupon: {
    creareDiscount: "/api/discount/create-discount",
    updateDiscount: "/api/discount/update-discount",
    getDiscount: "/api/discount/get-discounts",
    getSingle: "/api/discount/get-discount",
    update: "/api/discount/update-discount",
    delete: "/api/discount/delete-discount",
    validDescount: "/api/discount/validate-discount",
    listCoupons : "/api/discount/list-coupons",
  },
  booking: {
    createBooking: "/api/booking/create-booking",
    getAllBooking: "/api/booking/getAllBookings",
    getBookingById: "/api/booking/getBookingById",
    userBookings: "/api/booking/user-bookings",
    getAllOrders: "/api/booking/getAllOrder",
    getAdminBookingById: "/api/booking/getAdminBookingById",
    getAdminBookingFull: "/api/booking/getAdminBookingFull",
    getAdminBookingPDF: "/api/booking/getAdminBookingPDF",
    getAdminPaymentByBooking: "/api/booking/getAdminPaymentByBooking",
    getAdminTicketsByBooking: "/api/booking/getAdminTicketsByBooking",
    postAdminBookingResendEmail: "/api/booking/postAdminBookingResendEmail",
    eventBookings: (eventId) => `/api/booking/getEventBookings/${eventId}`,
    refundBooking: (bookingId) => `/api/booking/refundBooking/${bookingId}`,
  },
  wishlist: {
    addToWishlist: "/api/wishlist/add-to-wishlist",
    removeFromWishlist: "/api/wishlist/remove-from-wishlist",
    getWishlist: "/api/wishlist/get-wishlist",
  },
  review: {
    create: "/api/review/create-review",
    getReviews: "/api/review/get-reviews",
    deleteReviews: "/api/review/delete-review",
    editReviews: "/api/review/update-review",
    averageRating: "/api/review/get-average-rating",
    getAllReviews: "/api/review/getAllReviews",
    contact: "api/contact/sendContactEmail",
  },
  Payment: {
    createPaymentIntent: "/api/payment/create-payment-intent",
    getLivePayments: "/api/payment/get-live-payments-status",
    createCashBooking: "/api/payment/create-cash-booking",
    listCashBooking: "/api/payment/list-cash-bookings",
  },
  notice: {
    active: "/api/notice/active",
    adminList: "/api/notice/admin",
    create: "/api/notice/admin",
    update: (id) => `/api/notice/admin/${id}`,
    delete: (id) => `/api/notice/admin/${id}`,
  },
  user: {
    updateProfile: "api/user/updateUserBasic",
    userProfile: "api/user/userProfile",
    listUsers: "api/user/listUsers",
    updateUserRole: (userId) => `api/user/updateUserRole/${userId}`,
    exportUsers: "api/user/exportUsers",
  },
  dashboard: {
    getDashboardStats: "api/dashboard/getDashboardStats",
    getDashboardSeries: "api/dashboard/getDashboardSeries",
    bookingNotifications: "api/dashboard/booking-notifications",
    bookingNotificationsResendEmail: (bookingId) =>
      `api/dashboard/booking-notifications/${bookingId}/resend-email`,
    bookingNotificationsResendWhatsApp: (bookingId) =>
      `api/dashboard/booking-notifications/${bookingId}/resend-whatsapp`,
    bookingNotificationsResendSms: (bookingId) =>
      `api/dashboard/booking-notifications/${bookingId}/resend-sms`,
  },
  interest: {
    mark: (eventId) => `/api/interest-embedded/markIntersted/${eventId}`,
    unmark: (eventId) => `/api/interest-embedded/unmarkIntersted/${eventId}`,
    count: (eventId) => `/api/interest-embedded/count/${eventId}`,
    my: `/api/interest-embedded/my`,
  },
  scanner: {
    ticketInfo: "/api/ticket/scanTicketInfo",
    validateTicket: "/api/ticket/scanTicket",
  },
  /** Base URL already ends with /api — paths must NOT repeat /api */
  qrcode: {
    generateQr: "qrcode/generate-qr",
    generateQrStatus: "qrcode/generate-qr/status",
    generatePdf: "qrcode/generate-pdf",
  },
  layout: {
    getSeat: "/api/layout/seats",
    book: "/api/layout/book",
    bookingsByUser: "/api/layout/bookings-by-user",
    listAllBooked: "/api/layout/booked-seats",
  },
  paymentReconciliation: {
    dailyReport: "/api/payment-reconciliation/daily-report",
    reconcile: "/api/payment-reconciliation/reconcile",
    dryRun: "/api/payment-reconciliation/reconcile?dryRun=true",
    cleanupExpired: "/api/payment-reconciliation/cleanup-expired",
    sendDailySummary: "/api/payment-reconciliation/send-daily-summary",
    checkLink: (linkId) => `/api/payment-reconciliation/check-link/${linkId}`,
    health: "/api/payment-reconciliation/health",
    retryPayment: (paymentId) => `/api/payment-reconciliation/retry/${paymentId}`,
    backup: "/api/payment-reconciliation/backup",
    recoverySuggestions: (paymentId) => `/api/payment-reconciliation/recovery-suggestions/${paymentId}`,
    autoRecover: "/api/payment-reconciliation/auto-recover",
    errors: "/api/payment-reconciliation/errors",
  },
};
